import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';
var buttonColors = {
  primary: {
    backgroundColor: '#0BB25F',
    color: 'white'
  },
  'secondary-color': {
    backgroundColor: 'white',
    borderColor: '#0BB25F',
    color: '#0BB25F',
    borderStyle: 'solid',
    borderWidth: 1
  },
  'secondary-gray': {
    backgroundColor: 'white',
    borderColor: '#DCDFE3',
    color: '#1F2024',
    borderStyle: 'solid',
    borderWidth: 1
  },
  'tertiary-color': {
    backgroundColor: '#DFF7EA',
    color: '#0BB25F'
  },
  'tertiary-gray': {
    backgroundColor: '#F0F2F5',
    color: '#1F2024'
  },
  'negative-primary': {
    backgroundColor: '#CF1124',
    color: 'white'
  },
  'negative-secondary': {
    backgroundColor: '#FDE7E9',
    color: '#CF1124'
  }
};
var commonButtonStyle = createRuntimeFn({
  defaultClassName: 'commonStyles__o8dgpie commonStyles__o8dgpid',
  variantClassNames: {
    color: {
      primary: 'commonStyles_color_primary__o8dgpif',
      'secondary-color': 'commonStyles_color_secondary-color__o8dgpig',
      'secondary-gray': 'commonStyles_color_secondary-gray__o8dgpih',
      'tertiary-color': 'commonStyles_color_tertiary-color__o8dgpii',
      'tertiary-gray': 'commonStyles_color_tertiary-gray__o8dgpij',
      'negative-primary': 'commonStyles_color_negative-primary__o8dgpik',
      'negative-secondary': 'commonStyles_color_negative-secondary__o8dgpil'
    },
    size: {
      xs: 'commonStyles_size_xs__o8dgpim',
      sm: 'commonStyles_size_sm__o8dgpin',
      md: 'commonStyles_size_md__o8dgpio',
      lg: 'commonStyles_size_lg__o8dgpip',
      xl: 'commonStyles_size_xl__o8dgpiq'
    },
    block: {
      true: 'commonStyles_block_true__o8dgpir'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var flexCenterContainer = 'commonStyles__o8dgpi0';
var iconInContainerButtonStyle = createRuntimeFn({
  defaultClassName: 'commonStyles__o8dgpi3',
  variantClassNames: {
    color: {
      primary: 'commonStyles_color_primary__o8dgpi5',
      'secondary-color': 'commonStyles_color_secondary-color__o8dgpi6',
      'secondary-gray': 'commonStyles_color_secondary-gray__o8dgpi7',
      'tertiary-color': 'commonStyles_color_tertiary-color__o8dgpi8',
      'tertiary-gray': 'commonStyles_color_tertiary-gray__o8dgpi9',
      'negative-primary': 'commonStyles_color_negative-primary__o8dgpia',
      'negative-secondary': 'commonStyles_color_negative-secondary__o8dgpib'
    },
    disabled: {
      true: 'commonStyles_disabled_true__o8dgpic'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var stateStyles = {
  hoverBackgroundColor: 'var(--o8dgpi1)',
  activeBackgroundColor: 'var(--o8dgpi2)'
};
export { buttonColors, commonButtonStyle, flexCenterContainer, iconInContainerButtonStyle, stateStyles };
